Object.defineProperty(exports,"__esModule",{value:true});exports.creators=exports.default=exports.SecuredProductCategory=exports.actions=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _reduxOrm=require('redux-orm');
var _utils=require('./utils');function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var actions=exports.actions={
UPSERT_SECURED_PRODUCTS:'UPSERT_SECURED_PRODUCTS',
UPDATE_SECURED_PRODUCTS:'UPDATE_SECURED_PRODUCTS',
UPDATE_SECURED_PRODUCT:'UPDATE_SECURED_PRODUCT'};


var SecuredProductCategory=exports.SecuredProductCategory={
SEEN:'seen',
CURRENT:'current',
MISSING:'missing',
RETIRED:'retired',
MANUAL:'manual'};var





SecuredProduct=function(_Model){_inherits(SecuredProduct,_Model);function SecuredProduct(){_classCallCheck(this,SecuredProduct);return _possibleConstructorReturn(this,(SecuredProduct.__proto__||Object.getPrototypeOf(SecuredProduct)).apply(this,arguments));}_createClass(SecuredProduct,[{key:'toString',value:function toString()






















































{
return'Secured product: '+this.id;
}},{key:'productName',value:function productName()


{
var name=this.productId?this.productId.model:this.otherProductName;
if(!name||name.trim()==''){
return'Unknown Product';
}
return name;
}},{key:'manufacturerName',value:function manufacturerName()

{
var name=this.manufacturerId?
this.manufacturerId.name:
this.otherManufacturerName;
if(!name||name.trim()==''){
return'Unknown Manufacturer';
}
return name;
}}],[{key:'reducer',value:function reducer(action,SecuredProduct,session){if(!action)return undefined;switch(action.type){case actions.UPSERT_SECURED_PRODUCTS:{var products=action.payload.products;products.forEach(function(r){SecuredProduct.upsert(r);});break;}case actions.UPDATE_SECURED_PRODUCTS:{var _products=action.payload.products;var productsToRemove=SecuredProduct.exclude(function(product){return _products.find(function(_ref){var id=_ref.id;return product.id===id;});});productsToRemove.toModelArray().forEach(deleteRelatedChildren);productsToRemove.delete();_products.forEach(function(product){var productExists=SecuredProduct.hasId(product.id);if(productExists){var oldProduct=SecuredProduct.withId(product.id);checkRelatedChildren(oldProduct,product);}SecuredProduct.upsert(product);});break;}case actions.UPDATE_SECURED_PRODUCT:{var product=action.payload.product;var productExists=SecuredProduct.hasId(product.id);if(productExists){var oldProduct=SecuredProduct.withId(product.id);checkRelatedChildren(oldProduct,product);}SecuredProduct.upsert(product);break;}}return undefined;}}]);return SecuredProduct;}(_reduxOrm.Model);exports.default=SecuredProduct;

SecuredProduct.modelName='SecuredProduct';

SecuredProduct.fields={
id:(0,_reduxOrm.attr)(),
name:(0,_reduxOrm.attr)(),
updatedAt:(0,_reduxOrm.attr)(),
createdAt:(0,_reduxOrm.attr)(),
lastSeenAt:(0,_reduxOrm.attr)(),
serialNumber:(0,_reduxOrm.attr)(),
portId:(0,_reduxOrm.attr)(),
portAddress:(0,_reduxOrm.attr)(),
otherManufacturerName:(0,_reduxOrm.attr)(),
otherProductName:(0,_reduxOrm.attr)(),
imageSerialNumber:(0,_reduxOrm.attr)(),
usbCapable:(0,_reduxOrm.attr)(),
positionId:(0,_reduxOrm.oneToOne)('Position','securedProductId'),
storeId:(0,_reduxOrm.fk)('Store','securedProductIds'),
productId:(0,_reduxOrm.fk)('Product','securedProductIds'),
manufacturerId:(0,_reduxOrm.fk)('Manufacturer','securedProductIds'),
device:(0,_reduxOrm.attr)(),
category:(0,_reduxOrm.attr)(),
retiredReason:(0,_reduxOrm.attr)(),
notes:(0,_reduxOrm.attr)(),
notesHtml:(0,_reduxOrm.attr)()};


var upsertSecuredProducts=function upsertSecuredProducts(securedProducts){
var objs=securedProducts?
securedProducts.map(function(p){return(
(0,_utils.filterInput)(SecuredProduct)(_extends({},
p,{
device:p.securityDevice})));}):


[];

return{
type:actions.UPSERT_SECURED_PRODUCTS,
payload:{
products:objs}};


};

var updateSecuredProducts=function updateSecuredProducts(securedProducts){
var objs=securedProducts?
securedProducts.map(function(p){return(
(0,_utils.filterInput)(SecuredProduct)(_extends({},
p,{
device:p.securityDevice})));}):


[];

return{
type:actions.UPDATE_SECURED_PRODUCTS,
payload:{
products:objs}};


};

var updateSecuredProduct=function updateSecuredProduct(securedProduct){
if(!securedProduct)return;

var filteredProduct=(0,_utils.filterInput)(SecuredProduct)(_extends({},
securedProduct,{
device:securedProduct.securityDevice}));

return{
type:actions.UPDATE_SECURED_PRODUCT,
payload:{product:filteredProduct}};

};

var creators=exports.creators={
upsertSecuredProducts:upsertSecuredProducts,
updateSecuredProducts:updateSecuredProducts,
updateSecuredProduct:updateSecuredProduct};


var checkRelatedChildren=function checkRelatedChildren(oldProduct,newProduct){
checkRelationshipToSecurityDevice(oldProduct,newProduct);
};

var checkRelationshipToSecurityDevice=function checkRelationshipToSecurityDevice(oldProduct,newProduct){
var existingSecurityDevice=oldProduct.securityDevice;
var newSecurityDevice=newProduct.device;

if(!existingSecurityDevice){
return;
}

if(
!newSecurityDevice||
existingSecurityDevice.id!==newSecurityDevice.id)
{
existingSecurityDevice.delete();
}
};

var deleteRelatedChildren=function deleteRelatedChildren(product){
product.securityDevice&&product.securityDevice.delete();
};